import {DT_SUCCESS} from '../get-templates/constants'
import {deleteAudit as deleteAuditAPI} from '../../../services/audits'

export async function deleteTemplate(id, dispatch) {
  try {
    let response = await deleteAuditAPI(id)
    dispatch({type: DT_SUCCESS, payload: id})
    return response
  } catch (e) {
    console.log(`Delete Template Failed: ${e}`)
    return e.response
  }
}
